var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 3.125C28.125 1.39648 26.7285 0 25 0C23.2715 0 21.875 1.39648 21.875 3.125V26.8262L14.707 19.6582C13.4863 18.4375 11.5039 18.4375 10.2832 19.6582C9.0625 20.8789 9.0625 22.8613 10.2832 24.082L22.7832 36.582C24.0039 37.8027 25.9863 37.8027 27.207 36.582L39.707 24.082C40.9277 22.8613 40.9277 20.8789 39.707 19.6582C38.4863 18.4375 36.5039 18.4375 35.2832 19.6582L28.125 26.8262V3.125ZM6.25 34.375C2.80273 34.375 0 37.1777 0 40.625V43.75C0 47.1973 2.80273 50 6.25 50H43.75C47.1973 50 50 47.1973 50 43.75V40.625C50 37.1777 47.1973 34.375 43.75 34.375H33.8379L29.4141 38.7988C26.9727 41.2402 23.0176 41.2402 20.5762 38.7988L16.1621 34.375H6.25ZM42.1875 39.8438C42.8091 39.8438 43.4052 40.0907 43.8448 40.5302C44.2843 40.9698 44.5312 41.5659 44.5312 42.1875C44.5312 42.8091 44.2843 43.4052 43.8448 43.8448C43.4052 44.2843 42.8091 44.5312 42.1875 44.5312C41.5659 44.5312 40.9698 44.2843 40.5302 43.8448C40.0907 43.4052 39.8438 42.8091 39.8438 42.1875C39.8438 41.5659 40.0907 40.9698 40.5302 40.5302C40.9698 40.0907 41.5659 39.8438 42.1875 39.8438Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.8b7c8e7e1460f0559f561cb7a2a1c6f1.svg";
export { ForwardRef as ReactComponent };